import type { ReactNode } from 'react';

import { ACCEPTED_IMAGE_TYPES } from '../../constants/mediaTypes';
import { cn } from '../../lib/utils';
import type { ImageUploadInputProps } from '../../types/fileUpload';
import { BaseUploadInput } from './BaseUploadInput';
import { MEDIA_FADE_IN_CLASS, revealMedia } from './mediaFadeIn';

interface Props extends ImageUploadInputProps {
  existingPreview?: ReactNode;
  onRemoveExisting?: () => void;
}

export function ImageUploadInput({
  name,
  label,
  required,
  description,
  dimensions,
  value = null,
  maxSize,
  onChange,
  onError,
  className,
  placeholderClassName,
  buttonType = 'add',
  buttonClassName,
  existingPreview,
  onRemoveExisting,
}: Props) {
  return (
    <BaseUploadInput
      name={name}
      label={label}
      required={required}
      description={description}
      dimensions={dimensions}
      value={value}
      onChange={onChange}
      onError={onError}
      className={className}
      placeholderClassName={placeholderClassName}
      buttonType={buttonType}
      buttonClassName={buttonClassName}
      accept={ACCEPTED_IMAGE_TYPES.join(',')}
      acceptedTypes={ACCEPTED_IMAGE_TYPES}
      maxSize={maxSize}
      existingPreview={existingPreview}
      onRemoveExisting={onRemoveExisting}
      renderPreview={(url) => (
        <img
          src={url}
          alt={`${label || name} preview`}
          onLoad={revealMedia}
          onError={revealMedia}
          className={cn(
            'block h-full w-full object-cover',
            MEDIA_FADE_IN_CLASS,
          )}
        />
      )}
    />
  );
}
